(() => {
  const ROOT_SELECTOR = '[data-japan-map]';
  const SUFFIX = '特産品ページ';

  // data-code を基準に都道府県名を確定（slug/titleの揺れに強い）
  const PREF_BY_CODE = {
    '01':'北海道','02':'青森県','03':'岩手県','04':'宮城県','05':'秋田県','06':'山形県','07':'福島県',
    '08':'茨城県','09':'栃木県','10':'群馬県','11':'埼玉県','12':'千葉県','13':'東京都','14':'神奈川県',
    '15':'新潟県','16':'富山県','17':'石川県','18':'福井県','19':'山梨県','20':'長野県',
    '21':'岐阜県','22':'静岡県','23':'愛知県','24':'三重県',
    '25':'滋賀県','26':'京都府','27':'大阪府','28':'兵庫県','29':'奈良県','30':'和歌山県',
    '31':'鳥取県','32':'島根県','33':'岡山県','34':'広島県','35':'山口県',
    '36':'徳島県','37':'香川県','38':'愛媛県','39':'高知県',
    '40':'福岡県','41':'佐賀県','42':'長崎県','43':'熊本県','44':'大分県','45':'宮崎県','46':'鹿児島県','47':'沖縄県'
  };

  const titleParts = (t) => {
    const raw = (t || '').trim();
    const parts = raw.split('/').map(x => x.trim());
    return { ja: parts[0] || '', en: parts[1] || '' };
  };

  const initOne = (mapEl) => {
    if (!mapEl || mapEl.dataset.initialized === 'true') return;
    mapEl.dataset.initialized = 'true';

    const tooltip = mapEl.querySelector('[data-japan-map-tooltip]');
    const svg = mapEl.querySelector('[data-japan-map-svg] svg');
    if (!svg) return;

    const tooltipMode = mapEl.dataset.tooltipMode || 'ja';
    const openNewTab = (mapEl.dataset.openNewTab || 'false') === 'true';

    // Okinawa: 完全無反応
    const disabledCodes = new Set(['47']);

    const getPref = (ev) => {
      const t = ev.target;
      if (!t || !t.closest) return null;
      const g = t.closest('g.prefecture');
      if (!g) return null;
      const codeRaw = (g.dataset.code || '').trim();
      const code2 = String(parseInt(codeRaw, 10)).padStart(2,'0');
      if (disabledCodes.has(code2)) return null;
      return g;
    };

    const getData = (prefEl) => {
      const title = prefEl.querySelector('title');
      const { ja, en } = titleParts(title ? title.textContent : '');
      const codeRaw = (prefEl.dataset.code || '').trim();
      const code2 = String(parseInt(codeRaw, 10)).padStart(2,'0');
      const ja_full = PREF_BY_CODE[code2] || ja; // 念のためフォールバック
      return { ja, en, code2, ja_full };
    };

    const getHref = (prefEl) => {
      const d = getData(prefEl);
      const name = `${d.ja_full}${SUFFIX}`;
      return `/collections/${encodeURIComponent(name)}`;
    };

    const showTooltip = (prefEl, x, y) => {
      if (!tooltip) return;

      if (!prefEl) {
        tooltip.classList.remove('is-visible');
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.style.transform = 'translate3d(-9999px,-9999px,0)';
        return;
      }

      const d = getData(prefEl);
      let label = d.ja_full; // 表示は常に正式名が安全
      if (tooltipMode === 'en') {
        const title = prefEl.querySelector('title');
        const { en } = titleParts(title ? title.textContent : '');
        label = en || d.ja_full;
      }
      if (tooltipMode === 'both') {
        const title = prefEl.querySelector('title');
        const { en } = titleParts(title ? title.textContent : '');
        label = `${d.ja_full} / ${en || ''}`.trim();
      }

      tooltip.textContent = label;
      tooltip.classList.add('is-visible');
      tooltip.setAttribute('aria-hidden', 'false');
      tooltip.style.transform = `translate3d(${x + 14}px,${y + 14}px,0)`;
    };

    const navigate = (href) => {
      if (!href) return;
      if (openNewTab) window.open(href, '_blank', 'noopener,noreferrer');
      else window.location.assign(href);
    };

    // 1タップ即遷移（capture=true）
    svg.addEventListener('click', (ev) => {
      const p = getPref(ev);
      if (!p) return;

      ev.preventDefault();
      ev.stopPropagation();

      svg.querySelectorAll('g.prefecture.is-active').forEach(el => el.classList.remove('is-active'));
      p.classList.add('is-active');

      navigate(getHref(p));
    }, true);

    // Tooltip（沖縄は getPref が null を返すので出ない）
    svg.addEventListener('pointermove', (ev) => {
      const p = getPref(ev);
      if (!p) return showTooltip(null);
      showTooltip(p, ev.clientX, ev.clientY);
    });
    svg.addEventListener('pointerleave', () => showTooltip(null));

    // Keyboard（任意）
    svg.addEventListener('keydown', (ev) => {
      const p = getPref(ev);
      if (!p) return;
      if (ev.key === 'Enter' || ev.key === ' ') {
        ev.preventDefault();
        navigate(getHref(p));
      }
    });

    // 沖縄をフォーカス不可に
    const ok = svg.querySelector('g.prefecture[data-code="47"]');
    if (ok) {
      ok.classList.add('is-disabled');
      ok.setAttribute('tabindex', '-1');
      ok.setAttribute('aria-hidden', 'true');
    }
  };

  const initAll = (root) => {
    (root || document).querySelectorAll(ROOT_SELECTOR).forEach(initOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
